import { render } from "./MensagemList.vue?vue&type=template&id=6778ec7a&scoped=true"
import script from "./MensagemList.vue?vue&type=script&lang=js"
export * from "./MensagemList.vue?vue&type=script&lang=js"

import "./MensagemList.vue?vue&type=style&index=0&id=6778ec7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6778ec7a"]])

export default __exports__